/**
 * 开一个空白标签页。
 *
 * `window.open` 在弹窗被拦截时返回 null（而不是抛错），所以要显式返回 null
 * 让调用方走"当前页跳转"的兜底 —— 客户点了至少有反应，而不是以为按钮坏了。
 *
 * 「页面内容」与「页头页脚」两页的「新标签页预览」都走这一份：两处各写一遍，
 * 迟早出现一处判了 null、另一处直接 `.close()` 崩在被拦截的浏览器上。
 */
export function openBlankTab(): Window | null {
  try {
    return window.open('about:blank', '_blank');
  } catch {
    return null;
  }
}
